import mixpanel from 'mixpanel-browser';
import { env } from '@/utils/env';

const token = env?.VITE_MIXPANEL_TOKEN;
const isDev = env?.VITE_NODE_ENV === 'development';

class MixpanelService {
  readonly enabled = !!token;

  constructor() {
    if (!this.enabled) return;
    mixpanel.init(token!, {
      debug: isDev,
      track_pageview: false,
      persistence: 'localStorage',
      record_sessions_percent: 100,
      record_idle_timeout_ms: 900000, // 15 min: split session if user idle this long
      record_max_ms: 900000, // 15 min: cap a single recording at this length
      // Override Mixpanel's default of masking all text; mask only password fields
      record_mask_text_selector: 'input[type="password"]',
      loaded: () => {
        if (isDev) console.info('[mixpanel] session replay started');
      },
    });
  }

  identify(userId: string, name: string, email: string): void {
    if (!this.enabled) return;
    mixpanel.identify(userId);
    mixpanel.people.set({ $name: name, $email: email });
  }

  reset(): void {
    if (!this.enabled) return;
    mixpanel.reset();
  }
}

export const mixpanelService = new MixpanelService();
